class AddToWishlistButton extends HTMLElement {
  constructor() {
    super();
    this.variantId = this.dataset.variantId;
    this.hasMoreOptions = this.dataset.hasMoreOptions == "true";
    this.button = this.querySelector("button") || this.querySelector("a");
  }

  connectedCallback() {
    this.button.addEventListener("click", (e) => {
      if (this.hasMoreOptions) return;
      e.preventDefault();
      document.dispatchEvent(
        new CustomEvent("wishlist:save", {
          detail: {
            handle: this.dataset.handle,
            variantId: this.variantId,
            placement: "card",
          },
        })
      );
    });
    document.addEventListener("wishlist:ready", () => {
      this.init();
    });
  }

  disconnectedCallback() {
    document.removeEventListener("wishlist:ready", () => {
      this.init();
    });
  }

  init() {
    if (window.wishlistItems?.includes(Number(this.variantId))) {
      this.button.classList.add("added");
    } else {
      this.button.classList.remove("added");
    }
    this.button.classList.add("loaded");
  }
}

customElements.define("add-to-wishlist", AddToWishlistButton);
